import type { Language } from '@hero/schema';
import { detectAgentLanguageFromText, resolveAgentLanguage } from './resolve-agent-language';

/**
 * @deprecated Prefer `detectAgentLanguageFromText` + `resolveAgentLanguage`.
 * Kept for dashboard transcript language hints.
 */
export const detectLanguageFromUserText = (
  text: string,
  fallback?: Language,
): Language =>
  resolveAgentLanguage({
    userText: text,
    fallback,
  });

export { detectAgentLanguageFromText, resolveAgentLanguage };
